module.exports = __webpack_public_path__ + "static/kbb-music-237306822d4e7442dff6d67fc65a95d1.png";